

















































































import VChartHeader from "@/components/chart/VChartHeader.vue";
import { Component, Vue, Watch } from "vue-property-decorator";
import SelectYearAndMonth from "@/common/ui/components/SelectYearAndMonth.vue";
import { getServiceRoles } from "../api/service-api";
import AppHeader from "./AppHeader.vue";
import { client } from "@/api/request";
import ProjectBreadCrumbs from "@/components/project/ProjectBreadCrumbs.vue";
import VNameAndAvatar from "@/components/VNameAndAvatar.vue";
import { IProjectStatus } from "@/api/project-api";
import { statusSearch, listStatus } from "@/status";

@Component({
  components: {
    VChartHeader,
    SelectYearAndMonth,
    AppHeader,
    ProjectBreadCrumbs,
    VNameAndAvatar
  }
})
export default class StatusListPage extends Vue {
  isLoading: boolean = false;

  roles: Record<string, string | number>[] = [];
  staffs: Record<string, string | number>[] = [];
  date = new Date();

  searchOptions: Record<string, string | number> = {
    role: "",
    staff: "",
    status: ""
  };
  message: string = "";
  projects: IProjectStatus[] = [];
  totalStatus: number[] = [];
  private statusSearch = statusSearch;

  created() {
    this.message = "";
    this.getRoles();
    this.getStaffs();
  }

  private async getRoles() {
    const serviceRoles = await getServiceRoles();

    this.roles = [{ text: "(職種)", value: "" }].concat(
      serviceRoles.map(role => ({
        text: role.name,
        value: role.id
      }))
    );
  }

  handleSearch(key: string, value: number) {
    this.searchOptions = {
      ...this.searchOptions,
      [key]: value
    };
    this.getProjectStatusList();
  }

  @Watch("roles", { immediate: true })
  onDefaultQueryChanged() {
    this.searchOptions = {
      ...this.searchOptions,
      role: this.roles[2] && this.roles[2].value
    };
  }

  private async getStaffs() {
    const data = await client.get("get_project_staff_service.php");

    this.staffs = [{ text: "(社員)", value: "" }].concat(
      data.map((item: any) => ({
        text: item.name,
        value: item.id
      }))
    );
  }

  private async getProjectStatusList() {
    this.message = "";
    this.isLoading = true;
    try {
      const data = await client.get(
        "get_project_status_list.php",
        this.searchOptions
      );
      this.projects = data.projects;
      this.totalStatus = data.totalStatus;
      if (!this.projects.length) {
        this.message = "検索結果はありません";
      }
    } finally {
      this.isLoading = false;
    }
  }

  getStatus(index: number): string {
    return listStatus[index];
  }
}
